import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenCsQnaQuestion from '../../../../views/cs/qna/common/OpenCsQnaQuestion';
import { csQnaActions } from '../../../../store/modules/cs/qna';

class OpenCsQnaQuestionContainer extends Component {
  render() {
    return <OpenCsQnaQuestion {...this.props} />;
  }
}

const mapDispatchToProps = {
  toggleModal: csQnaActions.toggleModal,
};

export default connect(null, mapDispatchToProps)(OpenCsQnaQuestionContainer);
